/* eslint-disable prefer-destructuring */
import React, { useState } from 'react';

import { useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import Swal from 'sweetalert2';

import WppButton from 'src/components/functional/WppButton';

import FooterCheckout from 'src/components/functional/FooterCheckout';
import CheckoutHeader from 'src/components/functional/HeaderCheckout';
import { subscriptionPlans } from 'src/data/subscripitonPlansData';
import { PurchaseResume } from './components/PurchaseResume';
import PurchasePayment from './components/PurchasePayment';
import PurchaseForms from './components/PurchaseForms';

import { ICustomerData } from '../../interfaces';
import { apiCheckout } from '../../api';

import { CheckoutComponent, ContainerCheckout, ContainerContent } from './style';

import loadingGIF from '../../../../assets/gifs/loading.png';

export default function SubscriptionCheckout(): JSX.Element {
  const { token, platform, planId } = useParams();

  const [customerData, setCustomerData] = useState<ICustomerData>();
  const [component, setComponent] = useState(0);
  const [planData, setPlanData] = useState(
    subscriptionPlans.find((plan) => plan.planId === planId)
  );

  const { isLoading: isLoadingCheckDiscount } = useQuery(
    ['checkUserHasDiscount', token],
    async () => apiCheckout.checkUserHasDiscount(token),
    {
      onSuccess: (hasDiscount) => {
        if (hasDiscount && planId === 'plan_3zqL3mSwOIv09eJ5') {
          setPlanData(subscriptionPlans[1]);
        }
      },
      refetchOnWindowFocus: false,
    }
  );

  const { isLoading: isLoadingSubInfo, data: subInfoData } = useQuery(
    ['getUserSubInfo', token],
    async () => apiCheckout.getUserSubInfo(token),
    {
      refetchOnWindowFocus: false,
    }
  );

  console.log('isLoadingSubInfo, subInfoData', isLoadingSubInfo, subInfoData);

  const { isLoading, isError } = useQuery(
    ['getUserInfo', token],
    async () => apiCheckout.getUserProfileInfo(token),
    {
      onError: () => {
        void Swal.fire({
          icon: 'error',
          title: 'Ocorreu um erro ao recuperar os dados!',
          text: 'Por favor, tente novamente mais tarde, ou contate a central.',
          iconColor: 'black',
          confirmButtonColor: 'black',
        });
      },
      onSuccess: (data) => {
        setCustomerData({
          customerName: `${data.firstName} ${data.lastName}`,
          customerEmail: data.email,
          zipCode: data.zipCode,
          customerCpf: '',
          street: '',
          neighborhood: '',
          city: data.city,
          state: data.state,
          streetNumber: '',
          customerPhone: data.phone,
          consultantId: data.consultantId,
          consultantName: data.consultantName,
          recipientId: data.recipientId,
          splitPercentage: data.splitPercentage,
        });
      },
      refetchOnWindowFocus: false,
    }
  );

  const renderComponent = (): JSX.Element => {
    if (component === 0)
      return (
        <PurchaseForms
          customerData={customerData}
          setCustomerData={setCustomerData}
          setComponent={setComponent}
        />
      );
    return (
      <PurchasePayment
        customerData={customerData}
        planData={planData}
        setComponent={setComponent}
        platform={platform}
      />
    );
  };

  return (
    <ContainerCheckout>
      <CheckoutHeader />
      <ContainerContent>
        {isLoading || isLoadingCheckDiscount || isError || isLoadingSubInfo ? (
          <img src={loadingGIF} alt="Loading spinning" width="100" height="100" />
        ) : (
          <>
            <PurchaseResume planData={planData} subInfoData={subInfoData} />
            <CheckoutComponent>{renderComponent()}</CheckoutComponent>
          </>
        )}
      </ContainerContent>
      <WppButton />
      <FooterCheckout />
    </ContainerCheckout>
  );
}
